// extracted by extract-css-chunks-webpack-plugin
module.exports = {"originalPrice":"originalPrice_uhuY1","discounted":"discounted_DlOvE"};